import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../src/img/YingChenLiuLogo.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-61bcd9e5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "website-logo",
  src: _imports_0,
  alt: "Element logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "website-logo",
  src: _imports_0,
  alt: "Element logo"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))

import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { locale } = useI18n({ useScope: 'global' });

const isDesktop = ref(window.innerWidth >= 769);
const isChinese = ref(locale.value === 'zh');

const updateLayout = () => {
  isDesktop.value = window.innerWidth >= 769;
};

const toggleLanguage = () => {
  const newLang = isChinese.value ? 'zh' : 'en';
  locale.value = newLang;
  localStorage.setItem('locale', newLang);
};

onMounted(() => {
  updateLayout();
  console.log('Initial isDesktop:', isDesktop.value);
  window.addEventListener('resize', updateLayout);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateLayout);
});

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { id: "full-screen" }, {
      default: _withCtx(() => [
        (isDesktop.value)
          ? (_openBlock(), _createBlock(_component_el_header, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu, {
                  "default-active": '0',
                  class: "el-menu-demo",
                  mode: "horizontal",
                  ellipsis: false,
                  router: true,
                  "text-color": "#303133"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, {
                      index: "0",
                      route: "/home"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _hoisted_3,
                    _createVNode(_component_el_menu_item, { index: "1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: isChinese.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isChinese).value = $event)),
                          "active-text": "中文",
                          onChange: toggleLanguage,
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, {
                      index: "2",
                      route: "/home"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('appView.home')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, {
                      index: "3",
                      route: "/about"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('appView.aboutMe')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, {
                      index: "4",
                      route: "/works"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('appView.works')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, {
                      index: "5",
                      route: "/projects"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('appView.project')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, {
                      index: "6",
                      route: "/photography"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('appView.photography')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_header, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu, {
                  "default-active": '0',
                  class: "el-menu-demo",
                  mode: "horizontal",
                  ellipsis: false,
                  router: true,
                  "menu-trigger": 'click',
                  "close-on-click-outside": true,
                  "text-color": "#303133"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, {
                      index: "0",
                      route: "/home"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }),
                    _hoisted_5,
                    _createVNode(_component_el_menu_item, {
                      index: "1",
                      id: "changeLanguage"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_switch, {
                          modelValue: isChinese.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isChinese).value = $event)),
                          "active-text": "中文",
                          onChange: toggleLanguage,
                          onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_sub_menu, {
                      index: "2",
                      route: "/home"
                    }, {
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('appView.view')), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, {
                          index: "2-1",
                          route: "/home"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('appView.home')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, {
                          index: "2-2",
                          route: "/about"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('appView.aboutMe')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, {
                          index: "2-3",
                          route: "/works"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('appView.works')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, {
                          index: "2-4",
                          route: "/projects"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('appView.project')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_menu_item, {
                          index: "2-5",
                          route: "/photography"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('appView.photography')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })),
        _createVNode(_component_el_main, { id: "main-content" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})